<template>
  <div class="space-y-2">
    <div v-if="title" class="text-md font-semibold text-gray-800 mb-2">{{ title }}</div>
    <div v-if="categories && categories.length > 0">
      <ChipListDisplay :items="formattedCategories" :emptyText="emptyText" />
    </div>
    <div v-else-if="typeof categories === 'object' && categories !== null && Object.keys(categories).length > 0">
      <!-- If categories is an object, e.g. { categoryName: count, ... } -->
      <ul class="space-y-1">
        <li v-for="(count, categoryName) in categories" :key="categoryName" class="text-sm flex justify-between">
          <span class="text-gray-700">{{ formatCategoryName(categoryName) }}:</span> 
          <span class="font-medium text-gray-600">{{ count }}</span>
        </li>
      </ul>
    </div>
    <div v-else class="text-sm text-gray-500 italic">
      {{ emptyText }}
    </div>
  </div>
</template>

<script>
import ChipListDisplay from './ChipListDisplay.vue';

export default {
  name: 'ImageCategoriesDisplay',
  components: {
    ChipListDisplay
  },
  props: {
    categories: { // Can be an array of strings or an object {categoryName: count}
      type: [Array, Object],
      default: () => []
    },
    title: {
      type: String,
      default: 'Image Categories'
    },
    emptyText: {
      type: String,
      default: 'No image categories available'
    }
  },
  computed: {
    formattedCategories() {
      if (Array.isArray(this.categories)) {
        return this.categories.map(cat => 
          typeof cat === 'object' && cat.name ? cat.name : this.formatCategoryName(cat)
        );
      }
      return null; // Handled by v-else-if for object type
    }
  },
  methods: {
    formatCategoryName(name) {
      if (typeof name !== 'string') return name;
      return name.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    }
  }
};
</script>

<style scoped>
/* Scoped styles */
</style> 